import React from 'react';

import { Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';
import { isMysteryShopAdmin, isMysteryShopShopper } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';
import { localizeAreaLabel } from 'utils/helpers/units';

import { useEditShopRequestModalContext } from './EditShopRequestModalContext';
import { SHOP_REQUEST_CHECKLIST, SHOP_REQUEST_SPECIAL_TYPE_CHECKLIST, SHOP_REQUEST_TYPE } from '../constants';
import ProgressBar from '../ProgressBar';
import { ShopRequestChecklistFields } from '../types';

const Container = styled.div`
  padding: 20px 10px 10px 20px;
  display: flex;
  flex-flow: column;
  box-sizing: border-box;
  width: 100%;
`;

const Title = styled(Typography.Text)`
  font-family: var(--font-bold);
`;

const Row = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const Column = styled.div`
  display: flex;
  flex-flow: column;
`;

const StyledCheckbox = styled(Checkbox)`
  margin-bottom: 10px;
  .ant-checkbox-inner {
    height: 18px;
    width: 18px;
  }
`;

const CheckboxLabel = styled.span`
  font-size: 14px;
  color: var(--text-primary);
`;

const PercentageBarContainer = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const EditShopRequestModalChecklist = () => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const { shopRequest, setShopRequest } = useEditShopRequestModalContext();

  const checkListEditingEnabled =
    (isMysteryShopShopper(currentUser) && currentUser?.PAUser_Id === shopRequest?.shopper?.userId) ||
    isMysteryShopAdmin(currentUser);
  const checklist =
    shopRequest?.request_type === SHOP_REQUEST_TYPE.MYSTERY_SHOP
      ? SHOP_REQUEST_CHECKLIST
      : SHOP_REQUEST_SPECIAL_TYPE_CHECKLIST;

  const checkedItems = checklist.filter((item) => shopRequest![item.id as keyof ShopRequestChecklistFields]);
  const checkedPercentage = Math.round((checkedItems.length / checklist.length) * 100);

  return (
    <Container data-test-id="sr-modal-checklist-parent">
      <Row>
        <Title>Checklist</Title>
        <PercentageBarContainer>
          {`${checkedPercentage}%`}
          <ProgressBar percentage={checkedPercentage} />
        </PercentageBarContainer>
      </Row>
      <Column>
        {checklist.map((item) => (
          <StyledCheckbox
            key={item.id}
            className={'green'}
            checked={shopRequest![item.id as keyof ShopRequestChecklistFields]}
            disabled={!checkListEditingEnabled}
            onChange={(event: CheckboxChangeEvent) => {
              if (shopRequest) {
                setShopRequest({ ...shopRequest, [item.id]: event.target.checked });
              }
            }}
          >
            <CheckboxLabel>{localizeAreaLabel(item.label, shopRequest?.community)}</CheckboxLabel>
          </StyledCheckbox>
        ))}
      </Column>
    </Container>
  );
};

export default EditShopRequestModalChecklist;
